package com.eladfinish.bible.contest.repository.analytics

import com.eladfinish.bible.contest.data.analytics.FirebaseAnalyticsDataSource

interface FirebaseAnalyticsRepository {

    fun setUserProperty(key: String, value: String?)

    fun clearUserProperties()

    fun setAnalyticsUserId(userId: String?)

    fun setCrashlyticsUserId(userId: String)

    fun setCrashlyticsCustomKey(key: String, value: String)
}

class FirebaseAnalyticsRepositoryImpl(
    private val firebaseAnalyticsDataSource: FirebaseAnalyticsDataSource,
): FirebaseAnalyticsRepository {

    override fun setUserProperty(key: String, value: String?) =
        firebaseAnalyticsDataSource.setUserProperty(key, value)

    override fun clearUserProperties() =
        firebaseAnalyticsDataSource.clearUserProperties()

    override fun setAnalyticsUserId(userId: String?) =
        firebaseAnalyticsDataSource.setAnalyticsUserId(userId)

    override fun setCrashlyticsUserId(userId: String) =
        firebaseAnalyticsDataSource.setCrashlyticsUserId(userId)

    override fun setCrashlyticsCustomKey(key: String, value: String) =
        firebaseAnalyticsDataSource.setCrashlyticsCustomKey(key, value)

}
